import React from 'react';

import styled from 'styled-components';

import ActionLink from '../action-button';
import BrandIcon from '../brand-icon';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 90%;
  ${Styles.desktop`
    max-width: ${Styles.layout.smallerSectionMaxWidth};
  `}

  svg {
    fill: ${Styles.color.primary};
    width: 40px;
  }
`;

const Header = styled.p`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.heavy};
  line-height: 1;
  margin-bottom: 0;
`;

const Subheader = styled.p`
  margin: 1rem 0 2rem 0;
`;

interface IProps {
  header: string;
  subheader: string;
  linkText: string;
  linkTo: string;
}

const EmptyState = ({ header, subheader, linkText, linkTo }: IProps) => {
  return (
    <Container>
      <BrandIcon />
      <Header>{header}</Header>
      <Subheader>{subheader}</Subheader>
      <ActionLink to={linkTo}>{linkText}</ActionLink>
    </Container>
  );
};

export default EmptyState;
